<button class="text-button" (click)="click()"  [disabled]="isDisabled"> 
    <div class="d-flex align-items-center gap-2">
        @if (lucidePrefixIcon) {
            <lucide-icon [name]="lucidePrefixIcon" [size]="lucidePrefixSize" [color]="lucidePrefixColor"></lucide-icon>
        }
        <span class="mt-1" [ngClass]="classesList">{{label|translate}}</span>
        <img [src]="icon" alt="" *ngIf="showIcon">
    </div>
</button>